/// <amd-module name="TFS/Admin/Common/RestClient/NewDomainUrlOrchestration" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\cloud.webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as NewDomainUrlOrchestration from "TFS/Admin/Common/Contracts/NewDomainUrlMigration";

export interface INewDomainUrlOrchestrationRestClient extends IVssRestClient {
    /**
     */
    getStatus(): Promise<NewDomainUrlOrchestration.ServicingOrchestrationRequestStatus>;
    /**
     * @param codexDomainUrls - 
     */
    queueMigration(codexDomainUrls: boolean): Promise<void>;
}

class NewDomainUrlOrchestrationRestClient extends RestClientBase implements INewDomainUrlOrchestrationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     */
    public async getStatus(
        ): Promise<NewDomainUrlOrchestration.ServicingOrchestrationRequestStatus> {

        return this.beginRequest<NewDomainUrlOrchestration.ServicingOrchestrationRequestStatus>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/NewDomainUrlOrchestration"
        });
    }

    /**
     * @param codexDomainUrls - 
     */
    public async queueMigration(
        codexDomainUrls: boolean
        ): Promise<void> {

        const queryValues: any = {
            codexDomainUrls: codexDomainUrls
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/NewDomainUrlOrchestration",
            queryParams: queryValues
        });
    }

}

export const NewDomainUrlOrchestrationClientName = "INewDomainUrlOrchestrationRestClient";

export function getNewDomainUrlOrchestrationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): INewDomainUrlOrchestrationRestClient {
    return pageContext.getRestClient<INewDomainUrlOrchestrationRestClient>(NewDomainUrlOrchestrationClientName, options);
}

RestClients.add(NewDomainUrlOrchestrationClientName, { 
    factory: NewDomainUrlOrchestrationRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
